import { Fragment } from "react";
import FormBuilder from "@components/FormBuilder";
import "react-nestable/dist/styles/index.css";
const App = () => {
  return (
    <Fragment>
        <FormBuilder />
    </Fragment>
  );
};

export default App;
